import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled, { css } from 'styled-components';
import {
  minBreakpointQuery,
  maxBreakpointQuery,
  sectionMargins,
  elementColours,
} from '../styles';
import { Container, Heading, HtmlContent, Button } from './ui';

const StyledImageContentBlocks = styled.section`
  ${sectionMargins()};
`;

const StyledItem = styled.div`
  background-color: ${({ backgroundColour }) => backgroundColour.hex};

  ${minBreakpointQuery.smedium`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: center;
  `}
`;

const StyledImage = styled(GatsbyImage)`
  ${maxBreakpointQuery.smedium`
    max-height: 500px;
  `}

  ${minBreakpointQuery.smedium`
    height: 100%;
  `}

  ${({ flip }) => {
    if (flip) {
      return css`
        ${minBreakpointQuery.smedium`
          grid-row: 1;
          grid-column: 2;
        `}
      `;
    }
  }}
`;

const StyledContent = styled.div`
  padding: 30px;

  ${minBreakpointQuery.small`
    padding: 40px;
  `}

  ${minBreakpointQuery.medium`
    padding-right: 60px;
    padding-left: 60px;
  `}

  ${minBreakpointQuery.large`
    padding: 50px 80px;
  `}

  ${minBreakpointQuery.xlarge`
    padding: 60px 100px;
  `}

  ${minBreakpointQuery.xxlarge`
    padding: 70px 120px;
  `}

  ${minBreakpointQuery.xxxlarge`
    padding: 80px 140px;
  `}

  ${minBreakpointQuery.xxxxlarge`
    padding: 90px 160px;
  `}
`;

const StyledText = styled(HtmlContent)`
  margin-top: 20px;

  ${minBreakpointQuery.small`
    margin-top: 25px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 30px;
  `}

  ul {
    li {
      padding-left: 28px;

      ${minBreakpointQuery.small`
        padding-left: 32px;
      `}

      ${minBreakpointQuery.large`
        padding-left: 36px;
      `}

      &:before {
        top: 5px;
        left: 5px;
        height: 14px;
        width: 8px;
        background: none;
        border: 3px solid ${elementColours.textColour};
        border-top: none;
        border-left: none;
        border-radius: 2px;
        transform: rotate(45deg);
      }
    }
  }
`;

const StyledButton = styled(Button)`
  margin-top: 20px;

  ${minBreakpointQuery.small`
    margin-top: 25px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 30px;
  `}
`;

const ImageContentBlocks = ({ items, startImageRight }) => (
  <StyledImageContentBlocks>
    <Container wide={true}>
      {items.map(({ image, heading, text, link, backgroundColour }, i) => (
        <StyledItem key={i} backgroundColour={backgroundColour}>
          <StyledImage
            image={image.gatsbyImageData}
            alt={image.alt}
            flip={startImageRight ? !i % 2 : i % 2}
          />
          <StyledContent>
            <Heading>{heading}</Heading>
            <StyledText content={text} />
            {link && <StyledButton to={link.pageUrl}>{link.text}</StyledButton>}
          </StyledContent>
        </StyledItem>
      ))}
    </Container>
  </StyledImageContentBlocks>
);

export default ImageContentBlocks;
